import React, { useCallback, useState } from 'react';

import { useParams } from 'react-router';

import { Alert, Box, CircularProgress, Stack, Typography } from '@mui/material';

import { useGetPropertyRooms } from '~/hooks/apis/accommodation/useGetPropertyRooms';

import AccommodationPropertyRoomImagesAccordionItem from './AccommodationPropertyRoomImagesAccordionItem';

export default function AccommodationPropertyRoomImagesSection() {
  const { propertyId } = useParams<{ propertyId: string }>();
  const [expandedRoomId, setExpandedRoomId] = useState<string | false>(false);

  const {
    data: rooms = [],
    isLoading,
    error,
  } = useGetPropertyRooms({
    propertyId,
    enabled: !!propertyId,
  });

  const handleExpandedRoomChange = useCallback((roomId: string, isExpanded: boolean) => {
    setExpandedRoomId(isExpanded ? roomId : false);
  }, []);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error">Error loading rooms: {error instanceof Error ? error.message : 'Unknown error'}</Alert>
    );
  }

  if (rooms.length === 0) {
    return <Alert severity="info">No rooms found for this property.</Alert>;
  }

  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="h6">Room Images</Typography>

      <Box>
        {rooms.map((room) => (
          <AccommodationPropertyRoomImagesAccordionItem
            key={room.id}
            roomId={room.id}
            roomName={room.name}
            isExpanded={expandedRoomId === room.id}
            onExpandedRoomChange={handleExpandedRoomChange}
          />
        ))}
      </Box>
    </Stack>
  );
}
